import { motion } from "framer-motion";

export const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const stagger = {
    hidden: {},
    show: { transition: { staggerChildren: 0.1 } },
};

export function Reveal({ children, className = "", delay = 0, ...props }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
            {...props}
        >
            {children}
        </motion.div>
    );
}

export function Eyebrow({ children }) {
    return (
        <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-violet-400" data-testid="section-eyebrow">
            {children}
        </p>
    );
}
